import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterTimePicker, FilterCheckBox } from './Filters';

const months = [
  'January', 
  'February', 
  'March', 
  'April', 
  'May', 
  'June', 
  'July', 
  'August', 
  'September', 
  'October', 
  'November', 
  'December'
];

class SeasonalCourtReportInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = 
    { 
      isLoading: false ,
      year: new Date().getFullYear(),
      month: new Date().getMonth()
    };
  }

  componentDidMount() {
  }

  render() {
    const { isLoading, errorMessage, seasonalCourtReportData } = this.state;

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Seasonal Court Reports'
              documentDescription='Seasonal Court Reports'
            />

            <h2 className='main-page-header'>
              Seasonal Court report
            </h2>

            <form>
              <label for="seasonal-court-report-year">Year</label>
              <select id="seasonal-court-report-year" value={this.state.year} onChange={e => this.setState({year: e.target.value})}>
                { [...Array(new Date().getFullYear() - 2021 + 1)]
                    .map((x,y) => <option>{2021 + y}</option>)}
              </select>

              <label for="seasonal-court-report-month">Month</label>
              <select id="seasonal-court-report-month" value={this.state.month} onChange={e => this.setState({month: e.target.value})}>
                { (this.state.year == new Date().getFullYear() ? months.slice(0, new Date().getMonth() + 1) : months)
                    .map((x,y) => <option value={y}>{x}</option>)}
              </select>
              <br />
              <br />
              <button type="submit" onClick={async (e) => {
                const parsedMonth = parseInt(this.state.month) + 1;
                const parsedYear = parseInt(this.state.year)
                e.preventDefault();
               
                try {
                  this.setState({ 
                    downloading: `Retrieving data for year ${parsedYear} and month ${parsedMonth} ...` });
                  var data = await this.props.api.seasonalcourts.getReport( {
                    year: parsedYear,
                    month: parsedMonth
                  });

                  this.downloadData(data, parsedYear, parsedMonth); 
                  
                  this.setState({ downloading: 'Download is ready' });
                } catch (e) {
                  this.setState({ downloading: 'Error while retrieving data' });
                  console.error(e);
                }
                
              }}>Get Report</button>
              
            </form>
            {
               
               <p><br /><br /><b>{this.state.downloading ? this.state.downloading : ''}</b></p>
            }
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }

  downloadData(data, year, month) {
    var binaryData = [];
    binaryData.push(data);      
    const blob = new Blob(binaryData, {type: "text/csv"});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `report-${year}-${month}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
}

const SeasonalCourtReport = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(SeasonalCourtReportInternal)
));

SeasonalCourtReport.requiresLogin = true;
SeasonalCourtReport.propTypes = { isLoggedIn: PropTypes.bool };

export default SeasonalCourtReport;